import { useParams } from 'react-router';

import { paths } from '@/app/router/paths';
import { AdminHeader } from './components/AdminHeader';
import { AdminRegion } from './components/AdminRegion';
import { UserDetail } from './components/UserDetail';
import { adminCopy } from './copy';
import { usePlatformUser } from './hooks';

/**
 * Platformbeheer - één persoon, op zijn uuid (`/admin/gebruikers/{uuid}`): het
 * account en elk bedrijf waar hij werkt, met de weg naar meekijken bij dát
 * bedrijf.
 */
export function AdminUserPage() {
    const { userId = '' } = useParams<{ userId: string }>();
    const user = usePlatformUser(userId);

    return (
        <div className="flex min-h-0 flex-1 flex-col">
            <AdminHeader
                back={{ to: paths.adminUsers, label: adminCopy.userBack }}
                eyebrow={`${adminCopy.eyebrowPlatform} · ${user.data?.email ?? adminCopy.userEyebrow}`}
                title={user.data?.name ?? adminCopy.userEyebrow}
            />

            <div className="flex-1 overflow-auto bg-[var(--surface-page)] px-7 pt-[22px] pb-8">
                <AdminRegion
                    title={adminCopy.userLoading}
                    errorTitle={adminCopy.userError}
                    query={user}
                    skeletonHeight={180}
                >
                    {user.data ? <UserDetail user={user.data} /> : null}
                </AdminRegion>
            </div>
        </div>
    );
}
